import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './reducers/auth.reducer';
import emiratesAndRegionReducer from './reducers/emiratesAndRegion.reducer';
import cartReducer from './reducers/cart.reducer';
import searchReducer from './reducers/search.reducer';
import storesReducer from './reducers/stores.reducer';
import compareReducer from './reducers/compare.reducer';
import comparesListReducer from './reducers/comparesList.reducer';
import favouriteProductsReducer from './reducers/favouriteProducts.reducer';
import notificationsProductsReducer from './reducers/notificationsProducts.reducer';
import messagesReducer from './reducers/messages.reduce';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const rootReducer = combineReducers({ 
   
    auth: authReducer,
    emiratesAndRegion: emiratesAndRegionReducer,
    stores: storesReducer,
    cart: cartReducer,
    comparesList: comparesListReducer,
    searchMode: searchReducer,
    favouriteProducts:favouriteProductsReducer,
    compare:compareReducer,
    notificationsProducts:notificationsProductsReducer,
    messages:messagesReducer
})
const persistConfig = {
    key: 'root',
    storage,
  }
  
  const persistedReducer = persistReducer(persistConfig, rootReducer);
//   export const store = configureStore({
//     reducer: persistedReducer,
//     devTools: process.env.NODE_ENV !== 'production',
//     middleware: [thunk]
//   })
export const whizzAppStore = configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
  })
export const persistor = persistStore(whizzAppStore)
